if ( typeof StoreHours === 'undefined' ) {

  class StoreHours {

    static getStatusForItem(item, now = new Date()) {
      if ( ! item || typeof StoreHoursUtils === 'undefined' ) return '';

      const timezone = item.dataset.timezone || 'Australia/Adelaide';
      const handle = item.dataset.handle;
      const localDate = StoreHoursUtils.dateInTimezone(now, timezone);
      const holiday = StoreHoursUtils.getHolidayForDate(handle, localDate);

      if ( holiday ) {
        if ( holiday.status === 'special_hours' && holiday.close_time ) {
          const dayAbbrev = StoreHoursUtils.dayAbbrevInTimezone(now, timezone);
          return StoreHoursUtils.formatHoursDisplay(holiday.close_time, dayAbbrev);
        }
        return holiday.badge_message || 'Closed — Public Holiday';
      }

      const dayIndex = StoreHoursUtils.dayIndexInTimezone(now, timezone);
      const dayAbbrev = StoreHoursUtils.dayAbbrevInTimezone(now, timezone);
      const hours = StoreHoursUtils.hoursFromDataset(item);
      return StoreHoursUtils.formatHoursDisplay(hours[dayIndex], dayAbbrev);
    }

    static getStatusLabel(item, now = new Date()) {
      const status = this.getStatusForItem(item, now);
      return status ? ` &nbsp;|&nbsp; ${status}` : '';
    }

  }

  window.StoreHours = StoreHours;

}

if ( typeof StoreSelector !== 'function' ) {

  class StoreSelector extends HTMLElement {

    constructor() {

      super();

      this.mainSelector = this.hasAttribute('data-main-selector');
      this.storeSelectorButton = this.mainSelector ? document.querySelector('[data-js-select-store]') : null;
      this.canChangeStore = true;

      const interactiveMap = document.getElementById(this.dataset.mapSelector);

      if ( this.mainSelector && this.hasAttribute('data-single-store') ) {
        localStorage.setItem('selected-store', this.querySelector('.store-selector-item').getAttribute('data-handle'));
      }
      const selectedStore = localStorage.getItem('selected-store');
      let selectedStoreFound = false;
      
      this.storesList = [];
      this.querySelectorAll('.store-selector-item').forEach(elm=>{

        const item = elm;
        this.storesList[item.dataset.handle] = item.dataset.title;
        this.#formatStoreHours(item);

        if ( selectedStore && selectedStore === item.getAttribute('data-handle') ) {

          this.#setSelectedStore(item, item);
          this.#changeSelectedStoreHandleContent(selectedStore);
          selectedStoreFound = true;

          if ( interactiveMap ) {
            interactiveMap.addEventListener('ready', ()=>{
              setTimeout(()=>{
                interactiveMap.triggerMarkerClick(item.dataset.handle);
              }, 1000);
            })
          }

        }

        if ( ! this.hasAttribute('data-single-store') ) {

          const toggleEl = document.createElement('div');
          toggleEl.classList = `js-accordion-tab-toggle ${this.mainSelector ? 'js-accordion-tab-toggle--main' : ''}`;
          toggleEl.tabIndex = 0;
          toggleEl.innerHTML = KROWN.settings.symbols.toggle_pack_alternate;
          item.querySelector('.js-accordion-tab').appendChild(toggleEl);

          if ( this.mainSelector ) {
            const changeStoreEv = e=>{
              this.#clearSelectedStore(item);
              this.#setSelectedStore(item, e.target);
              if ( interactiveMap ) {
                if ( item.classList.contains('store-selector-item--store--active') ) {
                  interactiveMap.triggerMarkerClick(item.dataset.handle);
                }
              }
            }
            item.querySelector('.store-selector-item__input-container').addEventListener('click', changeStoreEv);
            item.querySelector('.store-selector-item__input-container').addEventListener('keyup', e=>{
              if ( e.keyCode === window.KEYCODES.RETURN ) {
                changeStoreEv(e);
              }
            });
          }

          const openAccordionEv = () => {
            this.#openStoreTab(item);
            this.canChangeStore = false;

            if ( interactiveMap ) {
              if ( item.classList.contains('store-selector-item--active') ) {
                interactiveMap.triggerMarkerClick(item.dataset.handle);
              }
            }

            if ( item.querySelector('css-slider') ) {
              item.querySelector('css-slider').resetSlider();
            }
          }

          item.querySelector(`${this.mainSelector ? '.js-accordion-tab-toggle' : '.js-accordion-tab'}`).addEventListener('click', openAccordionEv);
          item.querySelector(`${this.mainSelector ? '.js-accordion-tab-toggle' : '.js-accordion-tab'}`).addEventListener('keyup', e=>{
            if ( e.keyCode === window.KEYCODES.RETURN ) {
              openAccordionEv();
            }
          });

        }

      });

      if ( this.storeSelectorButton && selectedStoreFound === false ) {
        this.storeSelectorButton.classList.add('show-select-label');
      }

      if ( interactiveMap ) {
        interactiveMap.addEventListener('marker', (e)=>{
          if ( this.canChangeStore ) {
            const item = this.querySelector(`.store-selector-item[data-handle="${e.detail.store}"]`);
            if ( ! item.classList.contains('store-selector-item--store--active' ) ) {
              this.#clearSelectedStore(item);
              this.#setSelectedStore(item, item);
            }
          } else {
            this.canChangeStore = true;
          }
        });
      }
      
      if ( document.querySelector('[data-js-select-store]') ) {
        document.querySelector('[data-js-select-store]').addEventListener('click', e=>{
          e.preventDefault();
          if ( this.querySelector('.store-selector-item--store--active') ) {
            const selectedStoreNew = this.querySelector('.store-selector-item--store--active').getAttribute('data-handle');
            localStorage.setItem('selected-store', selectedStoreNew);
            this.#changeSelectedStoreHandleContent(selectedStoreNew);
            document.dispatchEvent(new CustomEvent('storechanged', {
              detail: { store: selectedStoreNew },
            }));
          } else {
            localStorage.removeItem('selected-store');
            this.#changeSelectedStoreHandleContent();
            document.dispatchEvent(new CustomEvent('storechanged', {
              detail: { store: null },
            }));
          }
        });
      }

      if ( this.mainSelector ) {
        document.addEventListener('storechanged', (event) => {
          const store = event.detail?.store || localStorage.getItem('selected-store');
          if ( store ) {
            this.#syncActiveStoreFromStorage(store);
          }
        });

        document.addEventListener('visibilitychange', ()=>{
          if ( document.visibilityState === 'visible' ) {
            const active = localStorage.getItem('selected-store');
            if ( active ) {
              this.#changeSelectedStoreHandleContent(active);
            }
          }
        });

        if ( selectedStoreFound && selectedStore ) {
          document.dispatchEvent(new CustomEvent('storechanged', {
            detail: { store: selectedStore },
          }));
        }
      }

    }

    #openStoreTab(item) {
      const open = item.classList.contains('store-selector-item--active') ? false : true;
      this.querySelectorAll('.store-selector-item--active').forEach(elm=>{
        this.#slideUp(elm.querySelector('[role=tabpanel]'), 200);
        elm.classList.remove('store-selector-item--active');
      });
      if ( open ) {
        item.classList.add('store-selector-item--active');
        this.#slideDown(item.querySelector('[role=tabpanel]'), 200);
      }
    }

    #formatStoreHours(item) {
      if ( typeof StoreHoursUtils === 'undefined' ) {
        return;
      }

      item.querySelectorAll('[data-store-hours-row]').forEach(row => {
        const day = row.dataset.day;
        const formatted = StoreHoursUtils.formatHoursDisplay(row.dataset.hours, day);
        const value = row.querySelector('[data-store-hours-value]');

        if ( value ) {
          value.textContent = formatted.startsWith(`${day}: `)
            ? formatted.slice(day.length + 2)
            : formatted;
        }
      });
    }
    
    #clearSelectedStore(item) {
      if ( ! item.classList.contains('store-selector-item--store--active') && this.querySelector('.store-selector-item--store--active') ) {
        const activeInput = this.querySelector('.store-selector-item--store--active input');
        if ( activeInput ) {
          activeInput.checked = false;
        }
        this.querySelector('.store-selector-item--store--active').classList.remove('store-selector-item--store--active');
      }
    }

    #setSelectedStore(item, button) {
      item.classList.toggle('store-selector-item--store--active');
      if ( this.mainSelector ) {
        item.querySelector('input').checked = !item.querySelector('input').checked;
        button.setAttribute('aria-selected', button.getAttribute('aria-selected') === "true" ? "false" : "true");
        if ( this.storeSelectorButton ) {
          if ( item.classList.contains('store-selector-item--store--active') ) {
            this.storeSelectorButton.style.display = "block";
          } else {
            this.storeSelectorButton.style.display = "none";
          }
        }
      }
    }

    #syncActiveStoreFromStorage(store) {
      const item = this.querySelector(`.store-selector-item[data-handle="${store}"]`);
      if ( ! item ) {
        return;
      }

      if ( ! item.classList.contains('store-selector-item--store--active') ) {
        this.querySelectorAll('.store-selector-item--store--active').forEach(elm=>{
          elm.classList.remove('store-selector-item--store--active');
          const input = elm.querySelector('input');
          if ( input ) {
            input.checked = false;
          }
        });
        item.classList.add('store-selector-item--store--active');
        const input = item.querySelector('input');
        if ( input ) {
          input.checked = true;
        }
      }

      this.#changeSelectedStoreHandleContent(store);
    }

    #changeSelectedStoreHandleContent(store = null) {
      
      if ( this.mainSelector ) {

        document.querySelectorAll('[data-type="store-selector"]').forEach(storeSelectorHandle=>{

          if ( store ) {

            const activeItem = this.querySelector('.store-selector-item--store--active') ||
              this.querySelector(`.store-selector-item[data-handle="${store}"]`);

            let storeClosingHours = '';
            if ( typeof StoreHours !== 'undefined' && activeItem ) {
              storeClosingHours = StoreHours.getStatusLabel(activeItem);
            }

            storeSelectorHandle.querySelector('[data-store-title]').innerHTML = `${KROWN.settings.locales.store_selector_title_selected}${storeClosingHours}`;
            storeSelectorHandle.querySelector('[data-store-label]').textContent = this.storesList[store];

            if ( this.storeSelectorButton ) {
              this.storeSelectorButton.classList.add('show-change-label');
              this.storeSelectorButton.classList.remove('show-select-label');
            }

          } else {

            storeSelectorHandle.querySelector('[data-store-title]').textContent = KROWN.settings.locales.store_selector_title_default;
            storeSelectorHandle.querySelector('[data-store-label]').textContent = KROWN.settings.locales.store_selector_label;

          }

        })

      }

    }

		#slideUp(target, duration){
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.boxSizing = 'border-box';
			target.style.height = target.offsetHeight + 'px';
			target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			setTimeout(()=>{
				target.style.display = 'none';
				target.style.removeProperty('height');
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}

		#slideDown(target, duration) {
			target.style.removeProperty('display');
			var display = window.getComputedStyle(target).display;

			if (display === 'none')
				display = 'block';

			target.style.display = display;
			var height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			setTimeout(()=>{
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}

  }

  if ( typeof customElements.get('store-selector') === 'undefined' ) {
    customElements.define('store-selector', StoreSelector);
  }

}
